import { EventEmitter, Injectable } from '@angular/core';
import { FullscreenLayoutAreas } from '@src/assets/css/fullscreen.template.scss';

export interface MosItemEvent {
    storyGuid: string;
    mosCommand: string;
}
export interface MosClientCommandEvent {
    command: string;
    sidecar: FullscreenLayoutAreas;
    mosPluginId?: string;
}

@Injectable({
    providedIn: 'root',
})
export class MosEventService {
    private mosItemEmitter = new EventEmitter<MosItemEvent>();
    private mosItemEditEmitter = new EventEmitter<MosItemEvent & { mosItemId: string }>();
    private mosClientCommandEmitter = new EventEmitter<MosClientCommandEvent>();

    currentMirStatus: { mirItemId: string | null; mosCommand?: string; storyId?: string | null } | null = null;

    setCurrentMirStatus(status: { mirItemId: string | null; mosCommand?: string; storyId?: string | null } | null): void {
        this.currentMirStatus = status || null;
    }

    emitMosItem(event: MosItemEvent) {
        this.mosItemEmitter.emit(event);
    }

    emitMosItemEdit(event: MosItemEvent & { mosItemId: string }) {
        this.mosItemEditEmitter.emit(event);
    }

    emitMosClientCommand(event: MosClientCommandEvent) {
        this.mosClientCommandEmitter.emit(event);
    }

    onMosClientCommand() {
        return this.mosClientCommandEmitter;
    }

    onMosItem() {
        return this.mosItemEmitter;
    }

    onMosItemEdit() {
        return this.mosItemEditEmitter;
    }
}
